<template>
  <div class="container-fluid">
    <apexchart
      :key="chartKey"
      height="300"
      :options="chartOptions"
      :series="chartOptions.series"
    ></apexchart>
  </div>
</template>

<script>
export default {
  name: 'FundReserveChart',
  data() {
    return {
      chartKey: 0,
      chartOptions: {
        chart: {
          type: 'line',
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          fontFamily: 'IRANSans, Tahoma, Arial',
          offsetX: 0,
        },
        title: {
          text: 'تغییرات مانده ذخیره صندوق طی سنوات مالی',
          align: 'center',
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#5a4a42',
          },
        },
        stroke: {
          curve: 'straight',
          width: 2,
        },
        colors: ['#4472C4'],
        markers: {
          size: 6,
          colors: ['#4472C4'],
          strokeColors: '#fff',
          strokeWidth: 2,
          hover: {
            size: 8,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val.toLocaleString('en-US');
          },
          offsetY: -10,
          style: {
            fontSize: '11px',
            colors: ['#5a4a42'],
          },
          background: {
            enabled: false,
          },
        },
        grid: {
          borderColor: '#e0e0e0',
          row: {
            colors: ['transparent'],
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '12px',
              colors: '#333',
            },
          },
          axisBorder: {
            show: true,
            color: '#c0c0c0',
          },
          axisTicks: {
            show: true,
            color: '#c0c0c0',
          },
        },
        yaxis: {
          min: 0,
          max: 0,
          tickAmount: 6,
          forceNiceScale: false,
          labels: {
            formatter: function (val) {
              return val.toLocaleString('en-US');
            },
            style: {
              fontSize: '11px',
              colors: '#333',
            },
            offsetX: -60,
            align: 'right',
            maxWidth: 100,
          },
        },
        series: [
          {
            name: 'مانده ذخیره صندوق',
            data: [],
          },
        ],
        tooltip: {
          y: {
            formatter: function (val) {
              return val.toLocaleString('en-US') + ' ریال';
            },
          },
        },
      },
    };
  },
  methods: {
    roundUpToNiceNumber(value) {
      if (value === 0) return 100000000;
      
      const magnitude = Math.pow(10, Math.floor(Math.log10(value)));
      const normalized = value / magnitude;
      
      const niceNumbers = [1, 1.5, 2, 2.5, 3, 4, 4.5, 5, 6, 7, 8, 9, 10];
      let rounded = niceNumbers.find(num => num >= normalized) || 10;
      
      return rounded * magnitude;
    },
    calculateNiceStep(range) {
      const magnitude = Math.pow(10, Math.floor(Math.log10(range)));
      const normalized = range / magnitude;
      
      let step;
      if (normalized <= 2) step = 0.2 * magnitude;
      else if (normalized <= 5) step = 0.5 * magnitude;
      else step = 1 * magnitude;
      
      return step;
    },
    GetFundReserveData() {
      var DataAxiosRow = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'AllCharts/BalanceTrend',
        Token: this.$session.get('TokenNetPa'),
      };

      const formData = new FormData();
      formData.append('BnpCashazaId', this.$session.get('UserInfoNetPa').bnpCashDBtblAzaId);
      DataAxiosRow.ArryfildValue = formData;

      this.$PostFormData(DataAxiosRow).then((response) => {
        if (response.success && response.data) {
          const years = [];
          const values = [];

          response.data.forEach((element) => {
            years.push(element.sal);
            values.push(element.mande);
          });

          const minValue = Math.min(...values);
          const maxValue = Math.max(...values);

          const roundedMin = 0;

          const roundedMax = this.roundUpToNiceNumber(maxValue);

          const range = roundedMax - roundedMin;
          const step = this.calculateNiceStep(range);
          const tickAmount = Math.floor(range / step);

          this.chartOptions.xaxis.categories = years;
          this.chartOptions.series[0].data = values;
          this.chartOptions.yaxis.min = roundedMin;
          this.chartOptions.yaxis.max = roundedMax;
          this.chartOptions.yaxis.tickAmount = Math.max(4, Math.min(tickAmount, 10));
          this.chartKey++;
        }
      });
    },
  },
  created() {
    this.GetFundReserveData();
  },
};
</script>

<style scoped>
.container-fluid {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
}
</style>

